import React from 'react';
import '../../App.css';
import { Helmet } from 'react-helmet';
import { useMediaQuery } from 'react-responsive';
import Caroussel from './Acceuil/Caroussel';
import Apropos from "./Acceuil/Apropos";
import Nos_Secteur from "./Acceuil/Nos_Secteur";
import Nos_Acitivite from './Acceuil/Nos_Activite';
import PartnerCaroussel from './Acceuil/PartnerCaroussel';
import Footer from '../Footer';
import CountUp from './Acceuil/CountUp';
import { useTranslation } from 'react-i18next';


function Acceuil() {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const { t } = useTranslation();

  return (
    <>
    <Helmet>
        <meta charSet="utf-8" />
        <title>{t('Professional Inspectors - Bureau de contrôle')}</title>
        <meta name="description" content={t("Bureau de contrôle dans le domaine industriel, assure la vérification technique des équipements industriels conformément aux normes et réglementations en vigueur (ASME, AWS, API, AISI, ISO, NF, EN, etc.). Elle assure également les inspections périodiques de sécurité selon les normes nationales et internationales en vigueur.")} />
        <meta name="keywords" content={t("Bureau d'inspection, innovation, solutions d'entreprise, expertise sectorielle, plateforme révolutionnaire, boostez votre activité")} />
        <meta property="og:title" content={t("Professional Inspectors - Optimisez votre activité avec nos solutions innovantes")} />
        <meta property="og:description" content={t("Découvrez comment notre plateforme révolutionnaire peut booster votre entreprise. Solutions sur mesure, expertise sectorielle. Contactez-nous aujourd'hui!")} />
        <meta property="og:type" content="website bureau d'inspection"/>
        <link rel="canonical" href="/" /> 
    </Helmet>


      <Caroussel />
      <CountUp /> 
      <Apropos name="about" />
      <Nos_Secteur />
      <Nos_Acitivite />
      <PartnerCaroussel />
      <Footer />
    </>
  );
}

export default Acceuil;
